module.exports = __webpack_public_path__ + "static/media/img1.76c5999c.jpg";